import { TextField } from '@mui/material';
import { isNotNullOrUndefined } from '@vy/utils';
import type { Control, FieldValues, Path, PathValue } from 'react-hook-form';
import { Controller } from 'react-hook-form';

export const ControlledTextInput = <FormValues extends FieldValues>(props: {
  name: Path<FormValues>;
  control: Control<FormValues>;
  label?: string;
  placeholder?: string;
  defaultValue?: PathValue<FormValues, Path<FormValues>>;
  disabled?: boolean;
}) => {
  const { control, label, placeholder, name, defaultValue, disabled } = props;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
        <TextField
          fullWidth
          disabled={disabled}
          label={label}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          error={isNotNullOrUndefined(error)}
          helperText={error ? error.message : ''}
        />
      )}
    />
  );
};
